import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { reducer as reduxAsyncConnect } from 'ha/modules/ReduxConnect';
import hermesReducer from 'ha/modules/Hermes/reducer';
import languageSwitcher from 'ha/modules/LanguageSwitcher/reducer';
import authModal from 'ha/modules/AuthModal/reducer';
import activationModal from 'ha/modules/ActivationModal/reducers';
import authLogic from 'ha/modules/AuthLogic/reducer';
import modalsLogic from 'ha/modules/ModalsLogic/reducers';
import { STATE_NAME as MODALS_LOGIC } from 'ha/modules/ModalsLogic/constants';
import {
  reducer as navbarReducer,
  STATE_NAME as NAVBAR_STATE_NAME,
} from 'ha/modules/NavBar';
import uiReducer from 'ha/modules/UI/reducer';
import {
  reducer as alertsReducer,
  STATE_NAME as ALERTS_STATE_NAME,
} from 'ha/modules/Alertbar';
import {
  reducer as savedSearchesReducer,
  STATE_NAME as SAVED_SEARCHES,
} from 'ha/modules/SavedSearches';
import {
  reducer as experimentsReducer,
  STATE_NAME as EXPERIMENTS_STATE_NAME,
} from 'ha/modules/Experiments';
import featuredCities, {
  STATE_NAME as FEATURED_CITIES,
} from 'ha/modules/FeaturedCities';
import {
  reducer as favoriteListingReducer,
  STATE_NAME as FAVORITE_LISTING,
} from 'ha/modules/FavoriteListing';
import {
  featureFlagsReducer,
  STATE_NAME as FEATURE_FLAGS_STATE_NAME,
} from 'ha/modules/FeatureFlag';
import { STATE_NAME as INBOX_COUNTER } from 'ha/modules/InboxCounter/constants';
import inboxCounterReducer from 'ha/modules/InboxCounter/reducer';

import { STATE_NAME as EDIT_LISTING_STATE_NAME } from 'ha/pages/ListingEdit/constants';
import { STATE_NAME as UNIVERSITIES_STATE_NAME } from 'ha/pages/Universities/constants';
import { STATE_NAME as UNIVERSITY_SIGN_UP_STATE_NAME } from 'ha/pages/UniversitySignUp/constants';
import { STATE_NAME as PROFILE_EDIT_STATE_NAME } from 'ha/pages/ProfileEdit/constants';
import { STATE_NAME as LISTING_CALENDAR_STATE_NAME } from 'ha/pages/ListingCalendar/constants';
import { STATE_NAME as VERIFICATION_STATE_NAME } from 'ha/pages/Verification/constants';
import { STATE_NAME as RESERVATIONS_STATE_NAME } from 'ha/pages/Reservations/constants';
import { STATE_NAME as PAY_PAYMENT_REQUEST_STATE_NAME } from 'ha/pages/PayPaymentRequest/constants';
import { STATE_NAME as PAYMENT_METHODS_STATE_NAME } from 'ha/pages/PaymentMethods/constants';
import { STATE_NAME as LISTINGS_STATE_NAME } from 'ha/pages/Listings/constants';
import { STATE_NAME as PARTNER_REDIRECT_STATE_NAME } from 'ha/pages/PartnerRedirect/constants';
import { STATE_NAME as CITIES_STATE_NAME } from 'ha/pages/Cities/constants';
import { STATE_NAME as BOOKING_STATE_NAME } from 'ha/pages/Booking/constants';
import { STATE_NAME as SEARCH_STATE_NAME } from 'ha/pages/Search/constants';
import { STATE_NAME as VERIFY_PHONE_NUMBER } from 'ha/pages/VerifyPhoneNumber/constants';
import { STATE_NAME as BILLING_STATE_NAME } from 'ha/pages/PayoutsBilling/constants';
import { STATE_NAME as INVOICES_STATE_NAME } from 'ha/pages/PayoutsInvoices/constants';
import { STATE_NAME as COMMISSION_PLAN_STATE_NAME } from 'ha/pages/PayoutsPlan/constants';
import { STATE_NAME as PAYOUT_METHODS_STATE_NAME } from 'ha/pages/PayoutsPreferences/constants';
import { STATE_NAME as TALK_STATE_NAME } from 'ha/pages/Talk/constants';
import { STATE_NAME as TRANSACTION_HISTORY_STATE_NAME } from 'ha/pages/PayoutsHistory/constants';
import { STATE_NAME as SEARCH_ALERT_UNSUBSCRIBE_STATE_NAME } from 'ha/pages/SearchAlertsUnsubscribe/constants';
import { STATE_NAME as PAYOUTS_PAYMENT_REQUESTS_STATE_NAME } from 'ha/pages/PayoutsPaymentRequests/constants';
import { STATE_NAME as HOME_STATE_NAME } from 'ha/pages/Home/constants/stateName';

function createReducer(asyncReducers) {
  return combineReducers({
    reduxAsyncConnect,
    ui: uiReducer,
    [ALERTS_STATE_NAME]: alertsReducer,
    hermes: hermesReducer,
    form: formReducer,
    languageSwitcher,
    authModal,
    authLogic,
    [MODALS_LOGIC]: modalsLogic,
    activationModal,
    [NAVBAR_STATE_NAME]: navbarReducer,
    [SAVED_SEARCHES]: savedSearchesReducer,
    [FEATURED_CITIES]: featuredCities,
    [EXPERIMENTS_STATE_NAME]: experimentsReducer,
    [FAVORITE_LISTING]: favoriteListingReducer,
    [FEATURE_FLAGS_STATE_NAME]: featureFlagsReducer,
    [INBOX_COUNTER]: inboxCounterReducer,

    // Code splitting
    listing: state => state || {},
    [SEARCH_STATE_NAME]: state => state || {},
    userPage: state => state || {},
    sitemap: state => state || {},
    [CITIES_STATE_NAME]: state => state || {},
    [LISTINGS_STATE_NAME]: state => state || {},
    [PAY_PAYMENT_REQUEST_STATE_NAME]: state => state || {},
    [EDIT_LISTING_STATE_NAME]: state => state || {},
    [UNIVERSITIES_STATE_NAME]: state => state || {},
    [UNIVERSITY_SIGN_UP_STATE_NAME]: state => state || {},
    [PROFILE_EDIT_STATE_NAME]: state => state || {},
    [LISTING_CALENDAR_STATE_NAME]: state => state || {},
    [VERIFICATION_STATE_NAME]: state => state || {},
    [RESERVATIONS_STATE_NAME]: state => state || {},
    [PAYMENT_METHODS_STATE_NAME]: state => state || {},
    [BOOKING_STATE_NAME]: state => state || {},
    [VERIFY_PHONE_NUMBER]: state => state || {},
    [BILLING_STATE_NAME]: state => state || {},
    [INVOICES_STATE_NAME]: state => state || {},
    [COMMISSION_PLAN_STATE_NAME]: state => state || {},
    [PAYOUT_METHODS_STATE_NAME]: state => state || {},
    [TALK_STATE_NAME]: state => state || {},
    [TRANSACTION_HISTORY_STATE_NAME]: state => state || {},
    [SEARCH_ALERT_UNSUBSCRIBE_STATE_NAME]: state => state || {},
    [PARTNER_REDIRECT_STATE_NAME]: state => state || {},
    [PAYOUTS_PAYMENT_REQUESTS_STATE_NAME]: state => state || {},
    [HOME_STATE_NAME]: state => state || {},
    ...asyncReducers,
  });
}

export default asyncReducers => createReducer(asyncReducers);
